export const EMAIL_REGEX = /^.+@.+\..+$/;
export const PARSED_PHONE_REGEX = /^\+\d{3,17}$/;
export const UNPARSED_PHONE_REGEX = /^(?:00|\+)?\d{1,15}$/;
